/* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */
/* eslint-disable camelcase */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/no-did-mount-set-state */
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { addPromotions } from '../../../redux/actions/selectActions';
import VouchersApi from '../../../api/open-voucher';
import ApplicationApi from '../../../api/aplicaciones';
import Commons from '../../../commons/commons';
import PaymentApi from '../../../api/payment';
import Mundigea from '../../../api/mundigea';
import GetAgency from './getAgency';
import notesVoucher from '../vouchers-notes';
import IframePayment from './iframe-payment';
import './index-checkout.css';

class Checkout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      loadingMsg: 'Comprobando disponibilidad',
      vouchers: null,
      indexVoucherSeleccionado: 0,
      form: {
        nombre: '',
        apellido: '',
        dni: '',
        email: '',
        telefono: '',
      },
      forma_pago: 1,
      condicionesCheck: false,
      openModal: false,
      urlModal: '',
      hash: null,
    };
    this.handleChangeInput = this.handleChangeInput.bind(this);
    this.handleChangeCustom = this.handleChangeCustom.bind(this);
    this.handleSubmitForm = this.handleSubmitForm.bind(this);
    this.loadingScreen = this.loadingScreen.bind(this);
    this.onCloseModal = this.onCloseModal.bind(this);
  }

  obtenerPartesDePathname = () => {
    const pathname = window.location.pathname.replace('/buscarxpaquetes', '');

    const path =
      pathname[pathname.length - 1] === '/' ? pathname.substring(0, pathname.length - 1) : pathname;

    return path.split('/');
  };

  async componentDidMount() {
    const { app, addPromotions } = this.props;
    const [, , , voucherTypeId, voucherSelectedId] = this.obtenerPartesDePathname();

    const mundigea = await ApplicationApi.obtenerAplicacion('www.mundigea.com.ar');

    const paymentData = await PaymentApi.obtenerOpcionesPagoMundigea(app.token).then(
      (res) => res.data,
    );

    const vouchers = await VouchersApi.getVouchers(app.token).then((data) =>
      data.status ? data.object.ofertas : false,
    );

    addPromotions(paymentData);

    if (vouchers && vouchers.length > 0) {
      let indexSelected = 0;
      const byType = vouchers.filter(
        (voucher) => parseInt(voucher.tipoVoucherId) === parseInt(voucherTypeId),
      );
      const ordenedVoucherdOptions = byType.sort((a, b) => {
        return a.usoVoucher.cantidadUsos - b.usoVoucher.cantidadUsos;
      });

      ordenedVoucherdOptions.forEach((voucher, index) => {
        if (voucher.id === voucherSelectedId) {
          indexSelected = index;
        }
      });

      this.setState({
        hash: mundigea.access_token,
        vouchers: ordenedVoucherdOptions,
        indexVoucherSeleccionado: indexSelected,
        loading: false,
      });
    } else {
      this.setState({
        loading: false,
      });
    }
  }

  handleChangeInput(e) {
    this.setState((state) => ({
      form: {
        ...state.form,
        [e.target.name]: e.target.type === 'number' ? parseInt(e.target.value, 10) : e.target.value,
      },
    }));
  }

  handleChangeCustom(name, value) {
    this.setState({
      [name]: value,
    });
  }

  handleDeriveAgency(agency) {
    this.handleChangeCustom('agency', agency);
  }

  loadingScreen() {
    const { loadingMsg } = this.state;
    return (
      <div className="container">
        <div className="display-flex-center loading-space">
          <div className="loading-panel">
            <div className="loading-caption">
              {loadingMsg}
              <br />
              <br />
              <i className="fa fa-circle-o-notch fa-spin" />
            </div>
          </div>
        </div>
      </div>
    );
  }

  formatInput = (e) => {
    // Prevent characters that are not numbers ("e", ".", "+" & "-") ✨
    let checkIfNum;
    if (e.key !== undefined) {
      // Check if it's a "e", ".", "+" or "-"
      checkIfNum = e.key === 'e' || e.key === '.' || e.key === '+' || e.key === '-';
    } else if (e.keyCode !== undefined) {
      // Check if it's a "e" (69), "." (190), "+" (187) or "-" (189)
      checkIfNum = e.keyCode === 69 || e.keyCode === 190 || e.keyCode === 187 || e.keyCode === 189;
    }
    return checkIfNum && e.preventDefault();
  };

  checkPayments = (promotionsList = []) => {
    const ahora12 = promotionsList.filter((promo) => promo.bank.denomination === 'AHORA 12')[0]; // if exist true, else false
    const ahora18 = promotionsList.filter((promo) => promo.bank.denomination === 'AHORA 18')[0]; // if exist true, else false

    return [ahora12, ahora18];
  };

  pricePerInstallments = (interests, price, installments) => {
    return ((price * interests) / 100 + price) / installments;
  };

  // eslint-disable-next-line class-methods-use-this
  async confirmaDerivacion(agency) {
    try {
      return await Mundigea.confirmarDerivacion({
        defaultGroup: agency.defaultGroup,
        aplicacionId: agency.applicationId,
        tipoAccion: 2, // action buy
      });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
    return true;
  }

  handleSubmitForm(e) {
    e.preventDefault();
    const { form, formaPago, vouchers, indexVoucherSeleccionado, agency, hash } = this.state;
    const { app } = this.props;
    this.setState({ loading: true, loadingMsg: 'Procesando' });
    let datosCompra = {
      comprador: true,
      forma_pago: formaPago,
      aplicacion_id: app.applicationId,
      oferta_id: vouchers[indexVoucherSeleccionado].id,
      ...form,
      email: form.email.trim(),
    };

    // derivation
    if (agency) {
      datosCompra = {
        ...datosCompra,
        aplicacion_id: agency.applicationId,
        telefono: `${datosCompra.telefono} - RF:MDG`,
      };
    }

    VouchersApi.buy(datosCompra, hash).then((res) => {
      if (res.data && res.data.status) {
        const { object } = res.data;

        switch (formaPago) {
          case 1:
            // deposit
            if (object.voucherId) {
              if (agency) {
                this.confirmaDerivacion(agency, app.token)
                  .catch((err) => {
                    // eslint-disable-next-line no-console
                    console.error(err);
                  })
                  .finally(() => {
                    window.location.replace(
                      `/buscarxpaquetes/open-voucher/confirmacion/${object.voucherId}/?method=deposit`,
                    );
                  });
              } else {
                window.location.replace(
                  `/buscarxpaquetes/open-voucher/confirmacion/${object.voucherId}/?method=deposit`,
                );
              }
            } else {
              window.location.replace(
                '/buscarxpaquetes/open-voucher/confirmacion/error/?method=deposit',
              );
            }
            break;
          case 2:
            // credit card
            this.setState(
              {
                urlModal: object,
                openModal: true,
                loadingMsg: 'El pago esta siendo procesado en otra ventana',
              },
              () => {
                if (agency) {
                  this.confirmaDerivacion(agency);
                }
              },
            );
            break;
        }
      } else {
        alert(
          'Hubo un error y no se pudo completar tu solicitud, por favor contactate con nosotros.',
        );
        this.setState({ loading: false, loadingMsg: '' });
      }
    });
  }

  onCloseModal = () => {
    if (window.confirm('Vas a cerrar esta ventana, estás seguro?')) {
      window.location.replace('/buscarxpaquetes/open-voucher');
    }
  };

  render() {
    const {
      loading,
      form,
      vouchers,
      indexVoucherSeleccionado,
      condicionesCheck,
      forma_pago,
      openModal,
      urlModal,
    } = this.state;
    const { promotions, app } = this.props;

    if (!vouchers || loading) {
      return (
        <>
          <IframePayment url={urlModal} openModal={openModal} OnCloseModal={this.onCloseModal} />
          {this.loadingScreen()}
        </>
      );
    }

    const [ahora12, ahora18] = this.checkPayments(promotions.promociones || []);
    const voucher = vouchers[indexVoucherSeleccionado];

    return (
      <div className="voucher-checkout">
        <div className="container">
          <div className="row panels-checkout">
            <div className="col-md-8">
              <br />
              <br />
              <h1 className="fist-title">
                Felicidades estas a un paso de obtener tu Open Voucher
                <b>{voucher.tipoVoucher.descripcion}</b>!
              </h1>
              <p className="sec-title">Usalo como y cuando quieras!</p>
              <br />
              <br />

              <h2 className="seccion-title">
                <i className="fa fa-user" />
                &nbsp;&nbsp;Datos del comprador
              </h2>
              <form className="form-voucher" onSubmit={(e) => this.handleSubmitForm(e)}>
                <div className="row">
                  <div className="col-md-6 col-sm-12">
                    <div className="form-group">
                      <label className="control-label" htmlFor="nombre">
                        Nombre
                      </label>
                      <input
                        onChange={(e) => this.handleChangeInput(e)}
                        value={form.nombre}
                        name="nombre"
                        id="nombre"
                        placeholder="Como figura en el documento"
                        className="form-control"
                        type="text"
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-sm-12">
                    <div className="form-group">
                      <label className="control-label" htmlFor="apellido">
                        Apellido
                      </label>
                      <input
                        onChange={(e) => this.handleChangeInput(e)}
                        value={form.apellido}
                        name="apellido"
                        id="apellido"
                        placeholder="Como figura en el documento"
                        className="form-control"
                        type="text"
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-4 col-sm-12">
                    <div className="form-group">
                      <label className="control-label" htmlFor="dni">
                        DNI
                      </label>
                      <input
                        onChange={(e) => this.handleChangeInput(e)}
                        onKeyDown={this.formatInput}
                        value={form.dni}
                        name="dni"
                        id="dni"
                        type="number"
                        placeholder=""
                        className="form-control input-md"
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-4 col-sm-12">
                    <div className="form-group">
                      <label className="control-label" htmlFor="email">
                        Email
                      </label>
                      <input
                        onChange={(e) => this.handleChangeInput(e)}
                        value={form.email}
                        name="email"
                        id="email"
                        placeholder="@"
                        className="form-control"
                        type="text"
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-4 col-sm-12">
                    <div className="form-group">
                      <label className="control-label" htmlFor="telefono">
                        Telefono
                      </label>
                      <input
                        onChange={(e) => this.handleChangeInput(e)}
                        value={form.telefono}
                        name="telefono"
                        id="telefono"
                        type="text"
                        placeholder=""
                        className="form-control input-md"
                        required
                      />
                    </div>
                  </div>
                </div>
                <br />
                {parseInt(app.applicationId) === 1 && (
                  <>
                    <h2 className="seccion-title">
                      <i className="fa fa-map-marker" />
                      &nbsp;&nbsp;Encontraremos a tu agencia más cercana!
                    </h2>
                    <div className="row">
                      <GetAgency handleDerive={(agency) => this.handleDeriveAgency(agency)} />
                    </div>
                  </>
                )}
                <br />
                <h2 className="seccion-title">
                  <i className="fa fa-credit-card " />
                  &nbsp;&nbsp;Como vas a Pagar?
                </h2>
                <p className="info-pago">Podes pagar tu OPEN VOUCHER de las sigueintes formas</p>
                <div className="metodo-pago">
                  <label role="button">
                    <input
                      onChange={(e) =>
                        this.handleChangeCustom('forma_pago', parseInt(e.target.value))
                      }
                      type="radio"
                      value="1"
                      checked={parseInt(forma_pago) === 1}
                      role="button"
                    />
                    <i className="fa fa-money" aria-hidden="true" />
                    <span className="title-label">
                      <b>Contado con transferencia bancaria</b>
                    </span>
                  </label>
                </div>
                <div className="metodo-pago">
                  <label role="button">
                    <input
                      onChange={(e) =>
                        this.handleChangeCustom('forma_pago', parseInt(e.target.value))
                      }
                      type="radio"
                      value="2"
                      role="button"
                      checked={forma_pago === 2}
                    />
                    <i className="fa fa-credit-card" aria-hidden="true" />
                    <span className="title-label">
                      <b>Tarjeta de crédito</b>
                    </span>
                  </label>
                </div>

                <div className="info-pago">
                  {forma_pago === 1 && (
                    <p>
                      Una vez realizada la solicitud, nos contactaremos contigo para coordinar el
                      pago!
                    </p>
                  )}
                  {forma_pago === 2 && (
                    <ul className="initial lista-medios-pago">
                      {ahora12 && (
                        <li>
                          12 cuotas de
                          {voucher.moneda.descripcion}{' '}
                          {Commons.numberFixedToMoney(
                            this.pricePerInstallments(
                              ahora12.interests,
                              voucher.importe,
                              ahora12.installments,
                            ),
                          )}{' '}
                          con VISA o MASTERCARD PLAN AHORA 12
                        </li>
                      )}
                      {ahora12 && (
                        <li>
                          18 cuotas de
                          {voucher.moneda.descripcion}{' '}
                          {Commons.numberFixedToMoney(
                            this.pricePerInstallments(
                              ahora18.interests,
                              voucher.importe,
                              ahora18.installments,
                            ),
                          )}{' '}
                          con VISA o MASTERCARD PLAN AHORA 18
                        </li>
                      )}
                    </ul>
                  )}
                </div>
                <br />
                <div className="conditions">
                  <label>
                    <input
                      name="condicionesCheck"
                      type="checkbox"
                      checked={condicionesCheck}
                      onChange={(e) => this.handleChangeCustom(e.target.name, e.target.checked)}
                    />
                    &nbsp; Acepto&nbsp;
                    <a
                      href=""
                      className="conditions-link color-dinamico"
                      data-toggle="modal"
                      data-target="#condiciones-modal"
                    >
                      LOS TÉRMINOS Y CONDICIONES
                    </a>
                  </label>
                </div>
                {!condicionesCheck && (
                  <div className="warning-conditions">
                    Es necesario aceptar los términos y condiciones para continuar
                  </div>
                )}
                <br />
                <input
                  className={`color-dinamico-fondo action-buy ${
                    condicionesCheck ? '' : 'disabled'
                  }`}
                  type="submit"
                  disabled={!condicionesCheck}
                  value="Comprar"
                />
              </form>
            </div>
            <div className="col-md-4">
              <div className="voucher-info-container">
                <h2 className="seccion-title">
                  <i className="fa fa-info-circle" />
                  &nbsp;&nbsp;Tu Voucher
                </h2>
                <div className="panel-voucher-info">
                  <h1>
                    Open Voucher
                    <b>{voucher.tipoVoucher.descripcion}</b>
                  </h1>
                  <p>
                    Tenés <b>{voucher.usoVoucher.cantidadUsos} noches </b> en habitacion doble para
                    2 personas para usar en cualquiera de los alojamientos del listado cuando
                    quieras las veces que quieras y combinandolo como máste guste!
                    <br />
                    <br />
                    <b>Valido para estadias finalizadas hasta el 31/03/2021.</b>
                  </p>
                  <div className="voucher-precio">
                    <span className="moneda">{voucher.moneda.descripcion}</span>
                    <span className="precio">{Commons.numberFixedToMoney(voucher.importe)}</span>
                  </div>
                  {notesVoucher[voucher.tipoVoucherId] && (
                    <>
                      <br />
                      <div className="notes">
                        <b>IMPORTANTE:</b> {notesVoucher[voucher.tipoVoucherId]}
                      </div>
                      git bran
                    </>
                  )}
                </div>
              </div>
            </div>

            <div
              className="modal fade"
              id="condiciones-modal"
              tabIndex="-1"
              role="dialog"
              aria-labelledby="myModalLabel"
            >
              <div className="modal-dialog" role="document">
                <div className="modal-content">
                  <div className="modal-header">
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button>
                    <h4 className="modal-title" id="myModalLabel">
                      Términos y condiciones
                    </h4>
                  </div>
                  <div className="modal-body">
                    <b>CONDICIONES GENERALES. HOTELES:</b> Las habitaciones serán suites, singles,
                    dobles, triples; standard, de luxe y/o máster, dependiendo del voucher
                    contratado. El régimen de comidas y cantidad prevista de días de alojamiento
                    será según se indique en cada oportunidad. En el supuesto que la Operadora se
                    viera obligada a cambiar el hotel confirmado debido a acontecimientos no
                    imputables a su parte, su responsabilidad quedará delimitada a ofrecer un hotel
                    de igual categoría o superior. Los gastos de alojamiento, manutención,
                    transporte y otros que se originen a consecuencia de retrasos en salidas y
                    regresos de medios de transporte serán por cuenta del cliente. El día de
                    alojamiento hotelero se computa desde las quince horas y finaliza a las diez
                    horas del día siguiente, independientemente de la hora de llegada y de salida y
                    de la utilización completa o fraccionada del mismo.
                    <br />
                    <br />
                    <b>CANCELACIONES - REEMBOLSOS:</b> a) En caso que el pasajero decidiere desistir
                    y/o cancelar el hotel contratado, deberá notificar a la agencia de manera
                    fehaciente su decisión. Las cancelaciones y reembolsos estarán sujetos a las
                    condiciones generales de los hoteles contratados. Pudiendo la Operadora
                    descontar el importe de los gastos incurridos al efectuar las contrataciones con
                    más una comisión del diez por ciento sobre el costo total de los servicios ya
                    contratados con estos, en concepto de indemnización. b) Sin perjuicio de lo
                    contemplado en el apartado anterior, en las operaciones a crédito, además, no
                    habrá reembolso de los importes abonados en concepto de informes, gastos
                    administrativos, sellados e intereses. c) Los noches no utilizados pasada la
                    fecha de expiracion del vooucher mencionda anteriormente no tendran reembolso de
                    ningun tipo.
                    <br />
                    <br />
                    <b>SERVICIOS Y RUBROS NO INCLUIDOS:</b> a) Extras; bebidas, lavado de ropa,
                    propinas, gastos de comunicaciones o reservas, aranceles por servicios de spa y
                    otras tasas e impuestos vigentes o que se creen en el futuro y cualquier otro
                    servicio, tasa, etc. que no se encuentre incluido en la orden de servicio
                    emitida por la Operadora. b) Peajes, excursiones opcionales, entradas a parques;
                    seguros personales y/o de asistencia ni ningún otro servicio; tasas y /o
                    impuesto que no se encuentre expresamente indicado en la orden de servicio
                    emitida por la Operadora; c) Estadías, comidas y gastos adicionales originados
                    y/o derivados por cancelaciones y/o demoras en las salidas o llegadas de los
                    medios de transporte o por razones imprevistas ajenas a la Operadora. d) Gastos
                    e intereses en las contrataciones a crédito.
                    <br />
                    <br />
                    <b>Derecho al retracto:</b> El cliente podrá ejercer el derecho de retracto. El
                    Art. 1110 del Código Civil y Comercial de la Nación indica que en los contratos
                    celebrados fuera del establecimiento comercial y a distancia el consumidor tiene
                    el derecho irrenunciable de revocar la aceptación dentro de los diez días
                    computados a partir de la celebración del contrato. Dicho retracto conforme art.
                    1112 del Código citado debe ser notificada al Proveedor por escrito o medios
                    electrónicos o similares.
                    <br />
                    <br />
                    Operador TRAVELGEA SA. Legajo 15695 Talcahuano 833, piso 11º “B”. CABA. Cuit
                    30-70958738-9
                  </div>
                  <div className="modal-footer">
                    <button type="button" className="btn btn-default" data-dismiss="modal">
                      Cerrar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  promotions: state.promociones,
  app: state.applicationState,
});

const mapDispatchtoProps = (dispatch) => bindActionCreators({ addPromotions }, dispatch);

export default connect(mapStateToProps, mapDispatchtoProps)(Checkout);
